import MODULE_ID from './moduleId';
import index from './index';

// Components
import BegleitfahrtHeader from './BegleitfahrtHeader.vue';
import Begleitfahrt from './Begleitfahrt.vue';
import BegleitfahrtBewertungFormular from './views/BegleitfahrtBewertungFormular.vue';
import BegleitfahrtResultView from "@/modules/begleitfahrt/views/result/BegleitfahrtResultView.vue";
import BegleitfahrtResultViewHeader from "@/modules/begleitfahrt/BegleitfahrtResultViewHeader.vue";
import BegleitfahrtBewertungViewHeader from "@/modules/begleitfahrt/BegleitfahrtBewertungViewHeader.vue";

class BegleitfahrtRouteHandler {
  getRoutes = ({ moduleType }) => {
    return [
      {
        path: `/begleitfahrt/:instance`,
        name: 'begleitfahrt-main-page',
        meta: {
          moduleType,
          initiateSyncBeforeNav: true,
          MODULE_ID,
          baseRoute: true,
        },
        components: { default: Begleitfahrt, header: BegleitfahrtHeader },
      },
      {
        path: `/begleitfahrt/:instance/:userId`,
        name: 'begleitfahrt-mitarbeiter',
        meta: {
          moduleType,
          initiateSyncBeforeNav: true,
          MODULE_ID,
          baseRoute: true,
        },
        components: { default: Begleitfahrt, header: BegleitfahrtHeader },
      },
      {
        path: `/begleitfahrt/:instance/bewertung/:userId/:questionnaireId/:uuid/:topicId?`,
        name: 'begleitfahrt-bewertung-formular',
        meta: {
          moduleType,
          initiateSyncBeforeNav: false,
          MODULE_ID,
          baseRoute: true,
          backPath: (currentRouteParams) => {
            return `/begleitfahrt/${currentRouteParams.instance}/${currentRouteParams.userId}`;
          },
        },
        components: { default: BegleitfahrtBewertungFormular, header: BegleitfahrtBewertungViewHeader },
      },
      {
        path: `/begleitfahrt/:instance/:userId/:ratingId`,
        name: 'begleitfahrt-resultat-ansicht',
        meta: {
          moduleType,
          initiateSyncBeforeNav: false,
          MODULE_ID,
          baseRoute: true,
          backPath: (currentRouteParams) => {
            return `/begleitfahrt/${currentRouteParams.instance}/${currentRouteParams.userId}`;
          },
        },
        components: { default: BegleitfahrtResultView, header: BegleitfahrtResultViewHeader },
      },
    ];
  };
}

export default new BegleitfahrtRouteHandler();
